<header class="toolbar" role="banner">
    <h1>
        {{ title }}
        <img src="assets/logo-header.svg" alt="Pan American Energy"/>
    </h1>
    <div class="center">
        <span>Digital Well Handover</span>
    </div>
    <div class="right">
        <span *ngIf="canDownloadFile">
            <button (click)="exportDHOData();" matTooltip="Descargar los datos de DHO en un archivo formato .xlsx" mat-icon-button >
                <mat-icon class="material-icons-outlined button-prop">file_download</mat-icon>
              </button>
              
        </span>
        <span *ngIf="canDownloadFile" class = "separator"></span>
        <button *ngIf="this.powerBiUrl && this.powerBiUrl!=''" class = "container-button-bi" style ="margin-left:5px" matTooltip="Acceso Tablero Power BI" mat-button>
            <a class = "power-bi-url" target="_blank" [href]="this.powerBiUrl">
                <img src="assets/logo-power-bi.svg" alt="Power BI"/>
                <span style = "color:white; text-wrap: nowrap; margin-left:5px">Power BI</span>
            </a>
        </button>
        <span *ngIf="this.powerBiUrl && this.powerBiUrl!=''" class = "separator"></span>
        <mat-icon style = "margin-left:5px" *ngIf="firstname != '' && lastname != ''" class="material-icons-outlined" aria-hidden="false" aria-label="Account">account_circle_outline</mat-icon>
        <span style = "margin-left:5px; text-wrap:nowrap">{{firstname}} {{lastname}}</span>
        <span class = "separator"></span>
        <span style = "margin-left:5px" *ngIf="viewLogout"><button mat-button (click)="logout()" class = "button-prop button-margin">Logout</button></span>
        <mat-icon style = "margin-left:5px" class="material-icons-outlined" matTooltip="Contactar a: HHelpDWHO@pan-energy.com" [matTooltipHideDelay]="5000">help_outline</mat-icon>
    </div>
</header>
